import { Constants } from "./constants";
import { ArrayUtils } from "./array-utils";

export { getProductName, getValueParsed, getCustomFieldValueParsed, parseValue, parseAsTwoValues, parseAsTwoValuesAndGetSecond, parseValueAsArray, getPricing, getEmptyProductPrice };

function getProductName(name, productType, brand) {
    if (typeof name !== "string")
        return false;

    if (typeof productType !== "string")
        return name;

    switch (productType) {
        case Constants.PRODUCT.TYPES.PARTS:
            if (typeof brand === "string")
                name = `${brand} ${name}`;
            break;
        default:
            const skuSeperatorIndex = name.lastIndexOf(Constants.PRODUCT.SKU_SEPARATOR);
            if (skuSeperatorIndex > 0)
                name = name.substr(0, skuSeperatorIndex).trim();
            break;
    }

    return name;
}

function getValueParsed(dictionary, key) {
    if (typeof key !== "string" || typeof dictionary !== "object" || Object.keys(dictionary).length === 0)
        return null;

    let value = dictionary[key];
    return parseValue(value);
}

function getCustomFieldValueParsed(customFields, key) {
    if (!ArrayUtils.isNotEmpty(customFields))
        return null;
    if (typeof key !== "string")
        return null;
    
    let ctaIndex = customFields.findIndex(f => f.name === key);
    if (ctaIndex < 0)
        return null;
    
    let ctaValue = customFields[ctaIndex].value;
    ctaValue = parseValue(ctaValue);

    if (!ctaValue)
        return null;

    return ctaValue;
}

function parseValue(value) {
    if (typeof value === "string")
        return value.substring(value.indexOf(Constants.PRODUCT.PIPE_SEPARATOR) + 1);

    return null;
}

function parseValueAsArray(value, separator) {
    if (!separator)
        separator = Constants.PRODUCT.ARRAY_SEPARATOR

    const parsedValue = parseValue(value);

    return parsedValue ? parsedValue.split(separator) : [];
}

function parseAsTwoValues(value) {
    const EXPECTED_NUMBER_OF_SUBSTRINGS = 2;
    if (typeof value === "string") {
        let substrings = value.split(Constants.PRODUCT.PIPE_SEPARATOR, EXPECTED_NUMBER_OF_SUBSTRINGS);
        if (substrings.length === EXPECTED_NUMBER_OF_SUBSTRINGS)
            return substrings;
    }

    return null;
}

function parseAsTwoValuesAndGetSecond(value) {
    let parsedResult = parseAsTwoValues(value);
    return parsedResult ? parsedResult[1] : '';
}

function getPricing(price = 0, retail = 0, sale = 0) {
    var returnObject = getEmptyProductPrice();

    if (sale && price) {
        returnObject.main = Math.min(sale, price)
    } else if (sale) {
        returnObject.main = sale
    } else if (price) {
        returnObject.main = price
    }

    if (returnObject.main) {
        returnObject.crossed = retail > returnObject.main ? retail : null
        returnObject.saving = retail > returnObject.main ? retail - returnObject.main : null
    }

    return returnObject
}

function getEmptyProductPrice() {
    return { main: null, crossed: null, saving: null };
}